import quickFetch from 'quick-fetch';
import { http } from '../features/http';
import { storeTimeDifference } from '../utils/TimeUtils';
import { throttle } from 'underscore';
const throttledFetchers = {};
export function quickFetchOrGet(name, url = name) {
  const earlyProgress = quickFetch.getRequestStateByName(name);

  if (earlyProgress) {
    return new Promise((resolve, reject) => {
      earlyProgress.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest(name);
      });
      earlyProgress.onError(xhr => {
        if (xhr.status === 401) reject(xhr);else {
          resolve(http.get(url));
        }
        quickFetch.removeEarlyRequest(name);
      });
    });
  }

  return http.get(url);
}
export function getCachedThenNew(name, url, callbacks = {}, win = window) {
  let timeRetrievedFromCache = false;
  let {
    fromCacheStorage
  } = win.hubspot && win.hubspot.academy || {};
  fromCacheStorage = fromCacheStorage || {}; // Cache a throttled & bound version of quickFetchOrGet
  // for each value of url

  throttledFetchers[url] = throttledFetchers[url] || throttle((...args) => quickFetchOrGet(...args).then(result => ({
    result,
    timestamp: Date.now()
  })), 1000 * 60 * 5, {
    leading: true,
    trailing: false
  }).bind(null, name, url);
  const cachedResult = fromCacheStorage[name];

  if (cachedResult) {
    if (callbacks.onSuccess) callbacks.onSuccess(cachedResult);
    timeRetrievedFromCache = performance.now();
    delete fromCacheStorage[url];
  }

  const newResult = throttledFetchers[url]().then(result => {
    if (callbacks.onSuccess) callbacks.onSuccess(result);

    if (timeRetrievedFromCache && window.newrelic) {
      window.newrelic.addPageAction('saved-load-time-using-cache', {
        milliseconds: performance.now() - timeRetrievedFromCache,
        endpoint: url
      });
      timeRetrievedFromCache = false;
    }

    return result;
  }, callbacks.onError);
  return cachedResult ? Promise.resolve(cachedResult) : newResult;
}
export function storeTimeAndReturnData(response) {
  if (response.headers.date) {
    storeTimeDifference(response.headers.date);
  }

  return response.data;
}
export function clearThrottledFetchers() {
  Object.keys(throttledFetchers).forEach(key => delete throttledFetchers[key]);
}